import React from "react";
import User from "./User";
import logoSvg from "../../ux/svg/icons/Logo.svg";
import styles from "./TopBar.less";;

export const TopBar: React.FC = () => (
    <div className={styles.TopBar}>
        <div className={styles.LogoWrapper}>
            <div
                className={styles.LogoSymbol}
                onClick={() => {
                    localStorage.clear();
                    location.reload();
                }}
            >
                <img src={logoSvg}></img>
            </div>
            <div className={styles.RightWrapper}>
                <div className={styles.LogoType}>
                    <p>Alphatek</p>
                </div>
            </div>
        </div>
        <User />
    </div>
);

export default TopBar;
